import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import SocialProof from "@/components/sections/SocialProof";
import TopOfMind from "@/components/sections/TopOfMind";
import Footer from "@/components/sections/Footer";

/**
 * Home / landing page (/) — Hero + social proof + footer only.
 * Deep-dive content lives on its own dedicated routes.
 */
export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#050505] text-white min-h-screen overflow-x-hidden">
      <Header />
      <Hero />
      <TopOfMind />
      <SocialProof />
      <Footer />
    </main>
  );
}
